import store from "@/store";

export function isAuthenticated() {
  return store.state.user.isAuthenticated
}

export function isAliveToken(success = () => {}, error = () => {}) {
  /**
   * Проверяет актуальность аутентификационного токена и обновляет его при необходимости.
   * @param {function} succces - Callback фукнция при успешной проверке
   * @param {function} error - Callback функция при провальной проверке
   */
  if(store.getters['auth/isCheckExpired']()){
    store.dispatch('auth/CHECK_TOKEN_ALIVE').then(
      () => {
        success()
      }
    ).catch(error)
  } else {
    success()
  }
}

export function goToLoginPage(){
  /**
   * Выполняет перенаправление пользователя на страницу авторизации.
   */
  document.location.href = process.env.VUE_APP_LOGIN_HOST + `?from=${document.location.href}`
}
